<template>
  <div class="w-full px-6 py-4">
    <div class="mb-5 flex items-center">
      <o-icon icon="address" :size="20" class="mr-3 opacity-75" />
      <div>
        <p class="leading-none mb-1">
          {{ $t('components.customer.edit.address.addressDetails') }}
        </p>
        <p class="leading-none text-sm opacity-60">
          {{ $t('components.customer.edit.address.postalAddressInfo') }}
        </p>
      </div>
    </div>

    <div>
      <o-address v-model="_customer" />
      <!--<div class="flex space-x-4 mb-4">
        <o-field-group class="w-full" label="Address Line 1">
          <text-field v-model="customer.address" />
        </o-field-group>
      </div>

      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full" label="Address Line 2">
          <text-field v-model="customer.address2" />
        </o-field-group>
      </div>

      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full md:w-1/2" label="Suburb">
          <text-field v-model="customer.suburb" />
        </o-field-group>
        <o-field-group class="w-full md:w-1/2" :label="$t('general.city')">
          <text-field v-model="customer.city" />
        </o-field-group>
      </div>
      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full md:w-1/2" :label="$t('general.region')">
          <text-field v-model="customer.region" />
        </o-field-group>
        <o-field-group class="w-full md:w-1/2" :label="$t('general.postcode')">
          <text-field v-model="customer.postcode" />
        </o-field-group>
      </div>
      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full md:w-1/2" :label="$t('general.country')">
          <text-field v-model="customer.country" />
        </o-field-group>
      </div>-->
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  OAddress,
} from '@/components/elements'

import {
  TextField,
} from '@/components/fields'

interface Props {
  customer: Record<string, any>
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'update:customer', value: any): void
}>()

const _customer = computed({
  get () {
    return props.customer
  },
  set (value) {
    emit('update:customer', value)
  },
})
</script>
